import React from "react";
import _ from "lodash";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

import ManaIcons from "../../components/decklists/ManaIcons";

export default function PlayerPanel({ selectedPlayer }) {
   const deck = selectedPlayer.Player && selectedPlayer.Player.Decklists && _.find(selectedPlayer.Player.Decklists, function (deck) {
      if (deck && deck.Guid == selectedPlayer.decklistId) {
         return true;
      }
   });

   return (
      <Stack alignItems='center' spacing={6} sx={{ width: "100%" }}>
         <Typography
            variant='h3LEDViewer'
            sx={{
               textTransform: "uppercase",
               textAlign: "center",
               lineHeight: "1em",
               width: "100%",
               overflow: "hidden",
            }}
         >
            {selectedPlayer.Player && selectedPlayer.Player.FirstName}
            <br />
            {selectedPlayer.Player && selectedPlayer.Player.LastName}
         </Typography>

         {selectedPlayer.showResults && !selectedPlayer.playerStandings && (
            <Typography
               variant='h3LEDViewer'
               sx={{
                  textTransform: "uppercase",
                  textAlign: "center",
                  lineHeight: "1em",
                  width: "100%",
                  overflow: "hidden",
               }}
            >
               0-0
            </Typography>
         )}

         {selectedPlayer.showResults && selectedPlayer.playerStandings && (
            <Typography
               variant='h3LEDViewer'
               sx={{
                  textTransform: "uppercase",
                  textAlign: "center",
                  lineHeight: "1em",
                  width: "100%",
                  overflow: "hidden",
               }}
            >
               {selectedPlayer.playerStandings.MatchWins}-
               {selectedPlayer.playerStandings.MatchLosses}
               {selectedPlayer.playerStandings.MatchDraws > 0 && (
                  <>-{selectedPlayer.playerStandings.MatchDraws}</>
               )}
            </Typography>
         )}

         {deck && (
            <>
               <Typography
                  variant='h2vsViewer'
                  sx={{
                     textTransform: "uppercase",
                     textAlign: "center",
                     lineHeight: "1em",
                     width: "100%",
                     px: 8,
                  }}
               >
                  {deck.DecklistName}
               </Typography>


               <ManaIcons
                  width={45}
                  mana={{
                     IsWhite: deck.Colors.includes("W"),
                     IsBlue: deck.Colors.includes("U"),
                     IsBlack: deck.Colors.includes("B"),
                     IsRed: deck.Colors.includes("R"),
                     IsGreen: deck.Colors.includes("G"),
                     IsColorless: deck.Colors.includes("C"),
                  }}
               />
            </>
         )}
      </Stack>
   );
}
